const API = '/api'

async function request(url) {
  const res = await fetch(url)
  if (!res.ok) throw new Error(`HTTP ${res.status}: ${url}`)
  return res.json()
}

export const fetchService = (slug) => request(`${API}/services/${slug}`)
export const fetchSubService = (slug, subSlug) => request(`${API}/services/${slug}/sub/${subSlug}`)
export const fetchServices = () => request(`${API}/services`)

export async function submitOrder({ name, phone, serviceName }) {
  const res = await fetch(`${API}/orders`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, phone, serviceName }),
  })
  if (!res.ok) throw new Error(`HTTP ${res.status}: ${API}/orders`)
  return res.json()
}
